import { Component, OnInit, Input, AfterContentInit, ElementRef, ViewChild,  } from '@angular/core';
import { SvcServices } from 'app/services/svc.service';
import { popupService } from "app/services/popup.service";
import { PopupModalService } from 'app/services/popup-modal.service';
import { GuidService } from 'app/services/guid.service';
import { ContentService } from '../../../../services';

@Component({
  selector: 'popup-site-limited-access',
  templateUrl: './popup-site-limited-access.component.html',

})
export class PopupSiteLimitedAccessComponent implements OnInit {

  limitedAccessContent:any; 
  
  ariaTitleId: string;
  ariaBodyId: string;
  ariaDescribedBy: string;

  constructor(private _svcService: SvcServices,
              private _contentService: ContentService,
              private popupModalService: PopupModalService,
              private guidService: GuidService) { }

  ngOnInit() {
    this._contentService.module_content.subscribe((data)=>{
      if (data !== null && data !== undefined) {
        if((data.content && data.content.CARDS) || (data.value) ){
        this.limitedAccessContent = data.content.CARDS;
        }
      }
    });
  }

  ngAfterContentInit() {
    /* all aria required ids must be unique to keep screen reader from finding another instance of this component */
    this.ariaTitleId = this.guidService.getSimpleGuid();
    this.ariaBodyId = this.guidService.getSimpleGuid();
    
    // space separated string of all aria ids that are announced on open
    this.ariaDescribedBy = this.ariaTitleId + ' ' + this.ariaBodyId;
  }
  close() {
      this.popupModalService.closePopupContent.emit(null);
    }
}
